var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.384,
    height: 24,
    viewBox: "0 0 23.384 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-icon",
    transform: "translate(-0.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20448",
    "data-name": "Caminho 20448",
    d: "M12.479,14.265V10.986H23.528a10.857,10.857,0,0,1,.164,1.979,10.824,10.824,0,0,1-2.84,7.669A10.973,10.973,0,0,1,12.483,24,12.169,12.169,0,0,1,.308,12,12.169,12.169,0,0,1,12.483,0a11.434,11.434,0,0,1,8.223,3.307L18.392,5.62a8.358,8.358,0,0,0-5.913-2.341A8.608,8.608,0,0,0,3.873,12a8.608,8.608,0,0,0,8.606,8.721,8.028,8.028,0,0,0,6.059-2.4,6.793,6.793,0,0,0,1.777-4.059Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.5d36593c65aec302fce662b33c88c5a7.svg";
export { ForwardRef as ReactComponent };